import React, { forwardRef, useContext } from 'react';
import { FormBuilderContext } from '../engine/FormBuilderEngine';

import SubjectIcon from '@material-ui/icons/Subject';
import EditIcon from '@material-ui/icons/Edit';
import ListIcon from '@material-ui/icons/List';
import FlashOnIcon from '@material-ui/icons/FlashOn';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import RemindersIcon from '@material-ui/icons/Notifications';
import NotificationsIcon from '@material-ui/icons/Email';
import MuiReplyIcon from '@material-ui/icons/Reply';
import SettingsIcon from '@material-ui/icons/Settings';
import TitleIcon from '@material-ui/icons/Title';
import Divider from '@material-ui/core/Divider';
import Tooltip from '@material-ui/core/Tooltip';
import IntegrationsIcon from '@material-ui/icons/SettingsInputComponent';

import CollapseableMenu from '../engine/CollapsableMenuEngine';
import { Sizes } from '../layouts/ng-layouts/Containers';

import styled from 'styled-components/macro';
import { useHistory } from 'react-router';
import BackButton from '../BackButton';
import Colors from '../../internal-components/Colors';

const ReplyIcon = styled(MuiReplyIcon)`
  && {
    transform: scaleX(-1);
  }
`;

const BackButtonContainer = styled.div`
  padding: 0.8rem;
  padding-bottom: 0;
  cursor: pointer;
  transition: 0.2s;
  overflow: hidden;

  & : hover {
    // background: rgba(0, 0, 0, 0.04);
    color: ${Colors.PRIMARY};
  }
`;

const BackButtonFlexContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;

  button {
    margin-right: 1.5rem;
  }
`;

const MenuBackButton = ({ currentFolder }) => {
  const history = useHistory();

  const goBack = () => {
    if (currentFolder && currentFolder !== '-1') {
      history.push(`/forms/folder/${currentFolder}`);
    } else {
      history.push('/forms');
    }
  };

  return (
    <BackButtonContainer onClick={goBack}>
      <BackButtonFlexContainer>
        <Tooltip arrow title="Back">
          <span>
            <BackButton
              data-testid="formbuilder-back-button"
              size="small"
              onClick={goBack}
            />
          </span>
        </Tooltip>
        <span>Back</span>
      </BackButtonFlexContainer>
      <Divider />
    </BackButtonContainer>
  );
};

const FormBuilderMenuView = props => {
  // console.log('menu render view');

  return (
    <CollapseableMenu
      topEndPoint={<MenuBackButton currentFolder={props.currentFolder} />}
      ref={props.menuRef}
      value={props.currentStage}
      setValue={props.setCurrentStage}
      noResizeBtn={props.isResizeBtnHidden}
      menuItems={[
        // {
        //   title: 'form-builder.tabs.description',
        //   value: 'overview',
        //   'data-testid': 'formbuilder-tab-overview',
        //   icon: <SubjectIcon fontSize="small" />
        // },
        {
          title: 'form-builder.tabs.builder',
          value: 'edit',
          'data-testid': 'formbuilder-tab-edit',
          icon: <EditIcon fontSize="small" />
        },
        {
          title: 'form-builder.tabs.statuses',
          value: 'statuses',
          'data-testid': 'formbuilder-tab-statuses',
          icon: <ListIcon fontSize="small" />
        },
        {
          title: 'form-builder.tabs.automations',
          value: 'automations',
          'data-testid': 'formbuilder-tab-automations',
          icon: <FlashOnIcon fontSize="small" />
        },
        {
          title: 'form-builder.tabs.admins',
          value: 'collaborate',
          'data-testid': 'formbuilder-tab-collaborate',
          privileges: ['form:create'],
          icon: <PersonAddIcon fontSize="small" />
        },
        {
          title: 'form-builder.tabs.reminders',
          value: 'reminders',
          'data-testid': 'formbuilder-tab-reminders',
          icon: <RemindersIcon fontSize="small" />
        },
        {
          title: 'form-builder.tabs.notifications',
          value: 'notifications',
          'data-testid': 'formbuilder-tab-notifications',
          icon: <NotificationsIcon fontSize="small" />
        },
        {
          title: 'form-builder.tabs.integrations',
          value: 'integrations',
          'data-testid': 'formbuilder-tab-integrations',
          privileges: ['form:create'],
          icon: <IntegrationsIcon fontSize="small" />
        },
        {
          title: 'form-builder.tabs.share',
          value: 'share',
          'data-testid': 'formbuilder-tab-share',
          privileges: ['form:create'],
          icon: <SettingsIcon fontSize="small" />
        },
        {
          title: 'form-builder.tabs.template',
          value: 'template',
          'data-testid': 'formbuilder-tab-template',
          privileges: ['templates:write'],
          icon: <TitleIcon fontSize="small" />
        }
      ]}
      additionalCSS={`height: calc(100vh - ${Sizes.NAV_BAR_HEIGHT}); top: ${Sizes.NAV_BAR_HEIGHT}px;`}
      {...props.collapsableMenuProps}
    />
  );
};

export default React.memo(FormBuilderMenuView);
